import React from 'react'
import Paper from 'material-ui/Paper'
import Grid from 'material-ui/Grid'
import Table from 'material-ui/Table'
import { TableBody } from 'material-ui/Table'
import { TableCell } from 'material-ui/Table'
import { TableHead } from 'material-ui/Table'
import { TableRow } from 'material-ui/Table'
import Typography from 'material-ui/Typography'
import Card, { CardContent } from 'material-ui/Card'
import Button from 'material-ui/Button'
import Icon from 'material-ui/Icon'
import { withStyles } from 'material-ui/styles'
import styles from './styles'
import { getFormattedNumberWithPrecision } from '../../../../../../common/utils'


class ResistanceUnbalnceSubtest extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      direction: 'row',
      justify: 'center',
      alignItems: 'center'
    }
  }
  render () {
    const {
      classes,
      translate,
      results,
      chartMeasurementUnit,
      subtestResultsDisplay,
      subtestResultsRemote,
      subtest,
      subtestRes
    } = this.props
    const { alignItems, direction, justify } = this.state
    let data = results.data.othersubtests.find(x => x.subtesttype === subtest)

    if(data) {
      let balanced = data.worst
      let unbalanced = null
      unbalanced = data.unbalancep2p ? data.unbalancep2p.worst : null
      return(
        <Grid container spacing={0}>
        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>

          <Grid
            container
            spacing={16}
            className={classes.subtestHeight}
            alignItems={alignItems}
            direction={direction}
            justify={justify}
          >
            <Grid item className={classes.tableContainer}>
              <Table>
                <TableHead>
                  <TableRow className={classes.tablerow}>
                  <TableCell className={classes.tableheader}></TableCell>
                    <TableCell className={classes.tableheader}>
                      {translate("general_pairs")}
                    </TableCell>
                    <TableCell className={classes.tableheader}>
                    {translate("general_limit")}(&#8486;)
                    </TableCell>
                    <TableCell className={classes.tableheader}>
                      {translate("general_values")}(&#8486;)
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  <TableRow className={classes.tablerow}>
                    <TableCell className={classes.tableheader}>{translate('general_intra_pair')}</TableCell>
                    <TableCell component='th'
                              scope='row'
                              className={classes.tableheader}>{ balanced ? balanced.pair : ''}
                    </TableCell>
                    <TableCell className={classes.tableheader}>{getFormattedNumberWithPrecision(balanced.limit, 3)}</TableCell>
                    <TableCell className={classes.tableheader}>{getFormattedNumberWithPrecision(balanced.value, 3)}</TableCell>
                  </TableRow>
                  { unbalanced &&
                  (<TableRow className={classes.tablerow}>
                    <TableCell className={classes.tableheader}>{translate('general_pair_to_pair')}</TableCell>
                    <TableCell component='th'
                            scope='row'
                            className={classes.tableheader}>{ unbalanced ? unbalanced.pair : ''}</TableCell>
                    <TableCell className={classes.tableheader}>{getFormattedNumberWithPrecision(unbalanced.limit, 3)}</TableCell>
                    <TableCell className={classes.tableheader}>{getFormattedNumberWithPrecision(unbalanced.value, 3)}</TableCell>
                    </TableRow>
                  )}
                  </TableBody>
              </Table>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      )
    }
    return null
  }
}

export default withStyles(styles)(ResistanceUnbalnceSubtest)
